import * as React from "react";
import { Button, Modal } from "react-ui";

import { ValueViewerValueContainer } from "./ValueViewer.styles";

interface ValueViewerProps {
    renderValue: () => React.ReactNode;
    children: (open: () => void) => React.ReactNode;
}

export function ValueViewer(props: ValueViewerProps): JSX.Element {
    const [opened, setOpened] = React.useState(false);

    return (
        <>
            {props.children(() => setOpened(true))}
            {opened && (
                <Modal onClose={() => setOpened(false)}>
                    <Modal.Header>Просмотр значения</Modal.Header>
                    <Modal.Body>
                        <ValueViewerValueContainer>{props.renderValue()}</ValueViewerValueContainer>
                    </Modal.Body>
                    <Modal.Footer panel>
                        <Button use="primary" onClick={() => setOpened(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}
